export default __webpack_public_path__ + "static/media/tedlogo.b7915314.png";